import CalendlyButton from './CalendlyButton'

const CalendlyCTA = () => {
  // Simple translation function
  const t = (k) => (window.accessI18n?.[k] ?? k);

  return (
    <div className='row justify-content-center mb-6'>
      <div className='col-xl-10'>
        <div className='row'>
          <div className='col-xl-6 mb-4 mb-xl-0'>
            <h3 className='fw-600 fs-4 mb-0'>{t("Let's turn your ADA scan into actionable solutions:")}</h3>
          </div>
          <div className='col-xl-6'>
            <CalendlyButton title={t("Schedule a Free Consultation")} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default CalendlyCTA;
